module.exports = __webpack_public_path__ + "static/media/sm.48089e01.svg";